export default ({
  containsAtLeast: { id: 'auth.containsAtLeast' },
  lowerCase: { id: 'auth.policy.lowerCase' },
  upperCase: { id: 'auth.policy.upperCase' },
  numbers: { id: 'auth.policy.numbers' },
  specialCharacters: { id: 'auth.policy.specialCharacters' },
  lengthAtLeast: { id: 'auth.lengthAtLeast' },
});
